<template>
</template>
<script>
export default {
    beforeCreate() {
        // 쿠콘 복귀(/api/plugins/open-bank/pay) → 서버 redirect 로 이 페이지가 iframe(또는 팝업) 안에서 열린다.
        // 부모/오프너의 checkpayComplete 로 결과(query)를 넘긴 뒤 닫는다.
        parent?.window?.checkpayComplete?.(this.$route.query);
        opener?.window?.checkpayComplete?.(this.$route.query);
        if (parent || opener) window.close();
    },
};
</script>
